import apiClient from '../client'

export const authService = {
  // Login
  login: async (credentials) => {
    const response = await apiClient.post('/auth/login', credentials)
    return response.data
  },

  // Register (company admin)
  register: async (payload) => {
    const response = await apiClient.post('/auth/register', payload)
    return response.data
  },

  // Get current user
  getMe: async () => {
    const response = await apiClient.get('/auth/me')
    return response.data
  },

  // Logout
  logout: async (refreshToken) => {
    const response = await apiClient.post('/auth/logout', { refreshToken })
    return response.data
  },

  // Forgot Password
  forgotPassword: async (email) => {
    const response = await apiClient.post('/auth/forgot-password', { email })
    return response.data
  },

  // Reset Password
  resetPassword: async (token, password) => {
    const response = await apiClient.post(`/auth/reset-password?token=${token}`, { password })
    return response.data
  },

  // Change Password
  changePassword: async (currentPassword, newPassword) => {
    const response = await apiClient.post('/users/change-password', {
      currentPassword,
      newPassword,
    })
    return response.data
  },

  // Update Profile
  updateProfile: async (profileData) => {
    const response = await apiClient.patch('/users/profile', profileData)
    return response.data
  },
}
